import React from "react";
import "styles/home.css";
import Spline3D from "components/home/Spline3D";

export default function Home() {
  return (
    <div className="h-screen w-screen overflow-hidden">
      <Spline3D />
    </div>
  );
}
